import { api } from "./api";
import {
  CreatePaymentResponse,
  PaymentStatusResponse,
  paymentType,
} from "@/types";
import { quotasUpgraded } from "@/types/api";

class BillingService {
  async createPayment(
    amount: number,
    product_name: string,
    payment_type: paymentType,
    quotasUpgraded?: quotasUpgraded,
  ): Promise<CreatePaymentResponse> {
    const response = await api.post<CreatePaymentResponse>("/admin/billing", {
      amount,
      product_name,
      payment_type,
      quotas: quotasUpgraded,
    });

    if (response.status !== 201) {
      throw new Error("Failed to create payment: " + response.data);
    }

    return response.data;
  }

  async verifyPayment(payment_id: string): Promise<PaymentStatusResponse> {
    const response = await api.get<PaymentStatusResponse>(
      `/admin/billing/${payment_id}/status`,
    );

    if (response.status !== 200) {
      throw new Error("Failed to verify payment");
    }
    console.log("response");
    console.log(response.data);

    return response.data;
  }
}

export const billingService = new BillingService();
